import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Card,
    CardBody,
    CardTitle,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Form,
    FormText,
} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
import Select from 'react-select';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
    postAPI_Create_Widget,
    putAPI_Update_Widget,
    gAPI_GetPlace_Predict,
} from '../../../../../constants/APIs';
import ServerAutoSuggest from '../data/ServerAutoSuggest';

import IntlMessages from '../../../../../helpers/IntlMessages';
let id = "";
export function EventSettingForm({ propertyId, layoutItem, LoadData, setIsEdit, eventData, eventId }) {
    const categories = [
        { label: "Academic", value: "Academic", key: 0 },
        { label: "Community", value: "Community", key: 1 },
        { label: "Concerts", value: "Concerts", key: 2 },
        { label: "Conferences", value: "Conferences", key: 3 },
        { label: "Expos", value: "Expos", key: 4 },
        { label: "FestivalsPerforming Arts", value: "FestivalsPerforming Arts", key: 5 },
        { label: "Sports", value: "Sports", key: 6 },
        { label: "Daylight Savings", value: "Daylight Savings", key: 7 },
        { label: "Observances", value: "Observances", key: 8 },
        { label: "Politics", value: "Politics", key: 9 },
        { label: "Public Holidays", value: "Public Holidays", key: 10 },
        { label: "School Holidays", value: "School Holidays", key: 11 }
    ]
    const [selectedOptions, setselectedOptions] = useState([]);
    const [inputData, setInputData] = useState([]);
    const [inputSettingData, setInputSettingData] = useState({
        Category: [],
        Miles: '',
        Places: []
    });
    const [placeValue, setPlaceValue] = useState('');
    const [placeEditValue, setPlaceEditValue] = useState('');
    const [newList, setNewList] = useState([]);
    const { messages } = "Search";
    useEffect(() => {
        let listAdd = [layoutItem.length === 0 ? 0 : (layoutItem.length + 1)].map((item, i) => {
            var y = Math.ceil(Math.random() * 4) + 1;
            return {
                w: 4,
                h: 6,
                x: (layoutItem.length * 2),
                y: (layoutItem.length === 0 ? 0 : ((layoutItem.length - 1) + 1)),
                i: (layoutItem.length === 0 ? 0 : ((layoutItem.length - 1) + 1)).toString(),
                static: false,
            };
        });
        setNewList(listAdd);
        if (eventId !== undefined) {
            let Setting = JSON.parse(eventData.settings);
            let category = [];
            Setting.Category.map((item) =>
                category.push(
                    categories.filter((cat) => cat.value === item)[0]
                )
            );
            setselectedOptions(category);
            let placeget = "";
            Setting.Places.map((item, i) =>
                placeget = (item.Id + " " + item.Name + " " + item.Country + " " + item.Location)
            )
            setPlaceEditValue(placeget);
            setInputData(Setting)
        }
    }, [eventId]);


    const handleChange = (e) => {
        setInputSettingData({
            ...inputSettingData,
            [e.target.name]: e.target.value
        });
        setInputData({
            ...inputData,
            Miles: e.target.value,
        });
    };
    const handleChangeMulti = (selectedOptions) => {
        setselectedOptions(selectedOptions);
        const categoriesArr = selectedOptions.map((elem) => elem.value);
        setInputSettingData({
            ...inputSettingData,
            Category: categoriesArr
        });
        setInputData({
            ...inputData,
            Category: categoriesArr,
        });
    };
    const onhandleSuggest = (inputText) => {
        setPlaceValue(inputText);
        setInputSettingData({
            ...inputSettingData,
            Places: [{
                Id: inputText.id,
                Name: inputText.name,
                Location: inputText.location,
                Country: inputText.country
            }]
        });
        setInputData({
            ...inputData,
            Places: [{
                Id: inputText.id,
                Name: inputText.name,
                Location: inputText.location,
                Country: inputText.country
            }],
        });
    };
    const handleSubmit = () => {
        if (eventId !== undefined) {
            let Update = {
                Id: eventData.id,
                groupId: getGroupID(),
                propertyId: propertyId,
                name: '',
                type: '3',
                position: [{
                    w: layoutItem.w,
                    h: layoutItem.h,
                    y: layoutItem.y,
                    x: layoutItem.x,
                    i: layoutItem.i,
                    static: false
                }],
                settings: {
                    Category: inputData.Category,
                    Places: inputData.Places,
                    Miles: inputData.Miles
                },
                Updator: 'dashboard',
            }
            AxiosAPI({
                method: 'put',
                url: `${putAPI_Update_Widget}/${eventData.id}`,
                data: Update
            })
                .then(res => {
                    LoadData()
                    setIsEdit(false);
                })
                .catch(err => {
                    console.log('err', err);
                });
        }
        else {
            let Create = {
                groupId: getGroupID(),
                propertyId: propertyId,
                name: '',
                type: '3',
                position: newList,
                settings: {
                    Category: inputData.Category,
                    Places: inputData.Places,
                    Miles: inputData.Miles
                },
                Creator: 'dashboard',
            }
            AxiosAPI({
                method: 'post',
                url: `${postAPI_Create_Widget}`,
                data: Create,
            })
                .then(res => {
                    LoadData()
                    setIsEdit(false);
                })
                .catch(err => {
                    console.log('err', err);
                });
        }
    };
    const handleCancel = () => {
        setInputSettingData({});
        if (eventId !== undefined) {
            setIsEdit(false);

        }
        else {
            setIsEdit(false);
        }
    };
    return (
        <Fragment>
            <Card>
                <CardBody>
                    <Form autoComplete="off">
                        <FormGroup>
                            <Label for="exampleEmail"> <IntlMessages id="dashboards.category" /></Label>
                            <Select
                                components={{ Input: CustomSelectInput }}
                                className="react-select"
                                classNamePrefix="react-select"
                                isMulti={true}
                                name="form-field-name"
                                value={selectedOptions}
                                onChange={handleChangeMulti}
                                options={categories}
                            ></Select>
                        </FormGroup>

                        <FormGroup>
                            <Label for="passwordBasic">Place</Label>
                            <FormText color="muted">
                                {placeEditValue}
                            </FormText>
                            <ServerAutoSuggest
                                getInputData={onhandleSuggest}
                            ></ServerAutoSuggest>
                        </FormGroup>

                        <FormGroup>
                            <Label>Miles</Label>
                            <Input
                                type="text"
                                name="Miles"
                                onChange={handleChange}
                                defaultValue={inputData.Miles}
                            >
                            </Input>
                        </FormGroup>

                        <Button color="primary" size="xs" onClick={handleSubmit} >
                            {eventId !== undefined ? ("Update") : ("Save")}
                        </Button>
                        <Button color="secondary" className="ml-2" size="xs" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </Form>
                </CardBody>
            </Card>

        </Fragment>
    );
}